import { Component, ViewChild, HostListener, ElementRef, Type, Injector } from "@angular/core";
import {
  BfxBlotterOrdersContextMenuService,
  BfxLadderBlotterOrdersContextMenuEvent,
} from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu.service";
import { BfxLadderBlotterContextMenuEventType } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBaseBlotterContextMenu } from "../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { BfxBlotterInboxContextMenuService } from "./bfx-blotter-inbox-contextmenu.service";
import { trigger, state, animate, transition, style } from "@angular/animations";
import {
  BfxBlotterContextMenuItem,
  BfxBlotterOrdersContextMenuItem,
  OrderDataPrimaryLookupService,
} from "shared/cubiq-services";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-blotter-inbox-context-menu",
  templateUrl: "./html/bfx-blotter-inbox-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  styleUrls: ["../bfx-base-blotter/bfx-base-blotter-contextmenu.less"],
  standalone: false,
})
export class BfxBlotterInboxContextMenu extends BfxBaseBlotterContextMenu<CubiqTS.OrderDataImpl> {
  constructor(
    injector: Injector,
    lookupService: OrderDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BfxBlotterInboxContextMenuService> {
    return BfxBlotterInboxContextMenuService;
  }

  public isItemEnabled(item: BfxBlotterOrdersContextMenuItem) {
    if (item == null) {
      return false;
    }
    return item.state.enabled;
  }

  public selectedMenuItem(item: BfxBlotterContextMenuItem<CubiqTS.OrderDataImpl>, event?: any) {
    if (this.isItemEnabled(item)) {
      (this.menuService as BfxBlotterOrdersContextMenuService).fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        null,
        null,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }
}
